var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 109,
    viewBox: "0 0 86 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-4{fill:none}.cls-1{stroke:#707070;stroke-width:2px}.cls-2{fill:#628a84}.cls-3{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Question",
    transform: "translate(-666 -510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_350",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23V22H0z",
    className: "cls-3",
    transform: "translate(682 522)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H22V21H1z",
    className: "cls-4",
    transform: "translate(682 522)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_351",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23V21H0z",
    className: "cls-3",
    transform: "translate(682 555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H22V20H1z",
    className: "cls-4",
    transform: "translate(682 555)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    transform: "translate(713.766 525.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_353",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V9H0z",
    className: "cls-3",
    transform: "translate(.235 -.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29V8H1z",
    className: "cls-4",
    transform: "translate(.235 -.454)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_354",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V6H0z",
    className: "cls-3",
    transform: "translate(.235 11.546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29V5H1z",
    className: "cls-4",
    transform: "translate(.235 11.546)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    transform: "translate(713.766 556.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_353-2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V8H0z",
    className: "cls-3",
    transform: "translate(.235 -.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29V7H1z",
    className: "cls-4",
    transform: "translate(.235 -.41)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_354-2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V8H0z",
    className: "cls-3",
    transform: "translate(.235 8.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29V7H1z",
    className: "cls-4",
    transform: "translate(.235 8.59)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    transform: "translate(713.766 588.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_353-3",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V8H0z",
    className: "cls-3",
    transform: "translate(.235 -.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29V7H1z",
    className: "cls-4",
    transform: "translate(.235 -.47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_354-3",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V8H0z",
    className: "cls-3",
    transform: "translate(.235 9.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29V7H1z",
    className: "cls-4",
    transform: "translate(.235 9.53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_352",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23V22H0z",
    className: "cls-3",
    transform: "translate(682 586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H22V21H1z",
    className: "cls-4",
    transform: "translate(682 586)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_349",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H86V109H0z",
    className: "cls-3",
    transform: "translate(666 510)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H85V108H1z",
    className: "cls-4",
    transform: "translate(666 510)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    d: "M1101.657 858.371a9.893 9.893 0 1 1 9.859 9.869 9.939 9.939 0 0 1-9.859-9.869zm9.126 1.342c-.982-.9-1.887-1.741-2.8-2.571a1.391 1.391 0 0 0-2.1 0 1.322 1.322 0 0 0 .134 2.072q1.925 1.808 3.865 3.6a1.291 1.291 0 0 0 2.064-.037q2.834-3.341 5.58-6.756a1.139 1.139 0 0 0-.233-1.774 2.5 2.5 0 0 0-1.811-.08c-.432.139-.735.713-1.068 1.116-1.195 1.442-2.375 2.894-3.631 4.429z",
    className: "cls-2",
    transform: "translate(-418.332 -324.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    d: "M1101.657 858.371a9.893 9.893 0 1 1 9.859 9.869 9.939 9.939 0 0 1-9.859-9.869zm9.126 1.342c-.982-.9-1.887-1.741-2.8-2.571a1.391 1.391 0 0 0-2.1 0 1.322 1.322 0 0 0 .134 2.072q1.925 1.808 3.865 3.6a1.291 1.291 0 0 0 2.064-.037q2.834-3.341 5.58-6.756a1.139 1.139 0 0 0-.233-1.774 2.5 2.5 0 0 0-1.811-.08c-.432.139-.735.713-1.068 1.116-1.195 1.442-2.375 2.894-3.631 4.429z",
    className: "cls-2",
    transform: "translate(-418.332 -292.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    d: "M1101.657 858.371a9.893 9.893 0 1 1 9.859 9.869 9.939 9.939 0 0 1-9.859-9.869zm9.126 1.342c-.982-.9-1.887-1.741-2.8-2.571a1.391 1.391 0 0 0-2.1 0 1.322 1.322 0 0 0 .134 2.072q1.925 1.808 3.865 3.6a1.291 1.291 0 0 0 2.064-.037q2.834-3.341 5.58-6.756a1.139 1.139 0 0 0-.233-1.774 2.5 2.5 0 0 0-1.811-.08c-.432.139-.735.713-1.068 1.116-1.195 1.442-2.375 2.894-3.631 4.429z",
    className: "cls-2",
    transform: "translate(-418.332 -261.348)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep01);
export default __webpack_public_path__ + "static/media/step0_1.88341a3b07c6d3e71bdb17212dfd32d0.svg";
export { ForwardRef as ReactComponent };